const rmsApiProxy = require('../api/rmsApiProxy');
const configurationManager = require('../config/configurationManager');
const currentOrgNodeSelectors = require('../../utils/state/stateSelectors/currentOrgNodeSelectors');

module.exports.getCloudinaryAssetUrl = function(resourceName)
{
    const cloudName = configurationManager.getConfig().cdnUsersCloudName;
    return `https://res.cloudinary.com/${cloudName}/image/upload/${resourceName}`
}

module.exports.getCloudinaryAppCloudName = function()
{
    return configurationManager.getConfig().cdnAppCloudName;
}

module.exports.getCloudinaryUsersCloudName = function()
{
    return configurationManager.getConfig().cdnUsersCloudName;
}

module.exports.isImgixAsset = function(assetUrl)
{
    if (assetUrl && typeof assetUrl === "string") {
        return assetUrl.includes('imgix.net');
    }
    return false;
}

module.exports.uploadImageFile = async function(imgFile, imageCategory) 
{
    if (imgFile instanceof File) {
        const form = new FormData();
        form.append('payload', imgFile);
        
        const resourceEndpoint = `imageUpload/${imageCategory}`;
        let requestUrl;

        if(currentOrgNodeSelectors.isCurrentSystemSelected())
        {
            requestUrl = `core/system/${resourceEndpoint}`;
        }
        else     
        {
            requestUrl = `${rmsApiProxy.getFranchisorOrgContextUrl()}/${resourceEndpoint}`;
        }

        const uploadedImageUrl = await rmsApiProxy.postForm(requestUrl, form);
        return uploadedImageUrl;        
    }

    throw new Error('argument must be an instance of File');
}

module.exports.uploadImageLink = async function(imgLink, imageCategory)
{
    if (typeof imgLink === "string") {
        const resourceEndpoint = `imageUpload/${imageCategory}`;
        let requestUrl;

        if(currentOrgNodeSelectors.isCurrentSystemSelected())
        {
            requestUrl = `core/system/${resourceEndpoint}`;
        }
        else     
        {
            requestUrl = `${rmsApiProxy.getFranchisorOrgContextUrl()}/${resourceEndpoint}`;
        }

        const uploadedImageUrl = await rmsApiProxy.post(requestUrl, {url: imgLink});
        return uploadedImageUrl;
    }

    throw new Error('argument must be of type string');
}

module.exports.getImgixBaseUrl = function ()
{
    return configurationManager.getConfig().rmsImgixCDNServerUrl;
}

module.exports.getBackOfficeImgixBaseUrl = function ()
{
    return `${this.getImgixBaseUrl()}/app/back.office`;
}
